import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  setactionType,
  setInterVal,
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../../../redux/slice/DashBoardSlice";
import { useDispatch } from "react-redux";
import AccordionComponent from "../../../../../common/Accordion";
import MonthIntervalDropdown from "../../../../../common/MonthIntervalDropdown";
import { getCaseActionsSummary } from "../../../../../services/ActionStatusApi";
import { Card, Col, Row } from "react-bootstrap";
import CommonProgressBar from "../CommonProgressBar";
import useAnimatedCounter from "../../../../ToDos/useAnimatedCounter";

interface ResultProps {
  onTabChange: () => void;
  openDropdown: string | null;
  setOpenDropdown: React.Dispatch<React.SetStateAction<string | null>>;
}
const CaseActionSummary: React.FC<ResultProps> = ({
  onTabChange,
  openDropdown,
  setOpenDropdown,
}) => {
  const dispatch = useDispatch();

  const [interval, setInterval] = useState<string>("1");
  const [intervalLabel, setIntervalLabel] = useState<string>("This Month");
  const [caseActions, setCaseActions] = useState<any[]>([]);

  const fetchCaseActions = async () => {
    try {
      const response = await getCaseActionsSummary(interval);
      setCaseActions(response);
    } catch (error) {
      console.error("Failed to fetch case actions:", error);
    }
  };

  const getValueByType = (type: string) =>
    caseActions.find((a) => a.actionType === type)?.actionTypeCount || 0;

  const [CaseActionKey, setCaseActionKey] = useState<string | null>("0");

  const handleBodyAccordionSelect = (key: string | null) => {
    // Prevent collapsing if the same key is clicked
    if (CaseActionKey === key) {
      return; // do nothing
    }
    setCaseActionKey(key || "0");
  };

  const CaseActionAccordion = (
    items: { title: JSX.Element; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={CaseActionKey}
      onSelect={handleBodyAccordionSelect}
    />
  );

  const handleIntervalChange = (
    intervalValue: string | number,
    label: string,
  ) => {
    setInterval(String(intervalValue));
    setIntervalLabel(label);
  };
  const getCaseInfoIdsByType = (type: string): number[] => {
    const ids = caseActions.find((a) => a.actionType === type)?.caseInfoIds;
    return ids ? ids.split(",").map((id: any) => Number(id.trim())) : [];
  };

  useEffect(() => {
    fetchCaseActions();
  }, [interval]);

  const handleCardClick = (type: string) => {
    const ids = getCaseInfoIdsByType(type);
    dispatch(setInterVal(Number(interval)));
    dispatch(setNewCaseInFoID(ids));
    setTimeout(() => {
      onTabChange();
    }, 800);
  };

  const historyPercentage = "80%";
  const RorPercentage = "65%";
  const EditorPercentage = "20%";

  const newCase = useAnimatedCounter(getValueByType("New Cases"));
  const closedCase = useAnimatedCounter(getValueByType("Closed Cases"));
  const cancelledCase = useAnimatedCounter(getValueByType("Cancelled Cases"));
  const historyPending = useAnimatedCounter(
    getValueByType("Historian Pending"),
  );
  const historyCompleted = useAnimatedCounter(
    getValueByType("Historian Completed"),
  );
  const rorPending = useAnimatedCounter(getValueByType("ROR Pending"));
  const rorCompleted = useAnimatedCounter(getValueByType("ROR Completed"));
  const editorPending = useAnimatedCounter(getValueByType("Editor Pending"));
  const editorCompleted = useAnimatedCounter(
    getValueByType("Editor Completed"),
  );

  return (
    <>
      {CaseActionAccordion([
        {
          title: (
            <div className="d-flex justify-content-between align-items-center w-100 p-0">
              <span className="">Case Actions</span>
              <MonthIntervalDropdown
                title={intervalLabel}
                onSelect={handleIntervalChange}
                stopPropagation={true}
                show={openDropdown === "actionMonth"}
                onToggle={(isOpen) =>
                  setOpenDropdown(isOpen ? "actionMonth" : null)
                }
              />
            </div>
          ),
          content: (
            <>
              <div>
                <Row className="g-3 fade-in-left">
                  <Col md={4}>
                    <Card
                      className="h-100 border-0"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#ddfcdd",
                        borderRadius: "8px",
                      }}
                      onClick={() => handleCardClick("New Cases")}
                    >
                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold cardTite_inf">
                            New Cases
                          </span>

                          <span
                            className="material-symbols-outlined first_bo first_bo1"
                            style={{ color: "#008200" }}
                          >
                            medical_services
                          </span>
                        </div>

                        <h4
                          className="fw-bold mb-0"
                          style={{ color: "#008200" }}
                        >
                          {newCase}
                        </h4>
                      </Card.Body>
                    </Card>
                  </Col>

                  {/* Closed Cases */}
                  <Col md={4}>
                    <Card
                      className="border-0  h-100"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#fbb3b4",
                        borderRadius: "8px",
                      }}
                      onClick={() => handleCardClick("Closed Cases")}
                    >
                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold cardTite_inf">
                            Closed Cases
                          </span>
                          <span
                            className="material-symbols-outlined first_bo first_bo2"
                            style={{ color: "#ee3036" }}
                          >
                            cancel
                          </span>
                        </div>

                        <h4
                          className="fw-bold mb-0"
                          style={{ color: "#ee3036" }}
                        >
                          {closedCase}
                        </h4>
                      </Card.Body>
                    </Card>
                  </Col>

                  {/* Cancelled Cases */}
                  <Col md={4}>
                    <Card
                      className="border-0  h-100"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#f2f2f2",
                        borderRadius: "8px",
                      }}
                      onClick={() => handleCardClick("Cancelled Cases")}
                    >
                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold cardTite_inf">
                            Cancelled Cases
                          </span>

                          <span
                            className="material-symbols-outlined first_bo first_bo3"
                            style={{ color: "#928c8b" }}
                          >
                            block
                          </span>
                        </div>

                        <h4
                          className="fw-bold mb-0"
                          style={{ color: "#928c8b" }}
                        >
                          {cancelledCase}
                        </h4>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <Row className="g-3 mt-3 fade-in-left">
                  <Col md={4}>
                    <Card
                      className="border-0 h-100"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#fdecbe",
                        borderRadius: "8px",
                      }}
                    >
                      <Card.Body className="p-3">
                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="fw-bold cardTite_inf">History</span>
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#9b6d15" }}
                          >
                            contract_edit
                          </span>
                        </div>

                        {/* Two Column Section */}
                        <div className="d-flex">
                          {/* Pending */}
                          <div className="flex-fill pe-2 border_right_dashboardCase_history">
                            <div className="small text-muted mb-1">Pending</div>
                            <h5
                              className="fw-bold mb-0 text-start"
                              style={{ color: "#ee383d" }}
                            >
                              {historyPending}
                            </h5>
                          </div>

                          {/* Completed */}
                          <div className="flex-fill ps-3">
                            <div className="small text-muted mb-1">
                              Completed
                            </div>
                            <h5
                              className="fw-bold mb-0 text-start"
                              style={{ color: "#9b6d15" }}
                            >
                              {historyCompleted}
                            </h5>
                          </div>
                        </div>
                        <div className="mt-3">
                          {/* <CommonProgressBar
                            percentage={historyPercentage}
                            primaryColor="#9b6d15"
                            secondaryColor="#f8e4b0"
                            textColor="#ffffff"
                          /> */}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md={4}>
                    <Card
                      className="border-0 h-100"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#d6f2fe",
                        borderRadius: "8px",
                      }}
                    >
                      <Card.Body className="p-3">
                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="fw-bold cardTite_inf">ROR</span>
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#0192d5" }}
                          >
                            article
                          </span>
                        </div>

                        {/* Two Column Section */}
                        <div className="d-flex">
                          {/* Pending */}
                          <div className="flex-fill pe-2 border_right_dashboardCase_ROR">
                            <div className="small text-muted mb-1">Pending</div>
                            <h5
                              className="fw-bold mb-0 text-start"
                              style={{ color: "#ee383d" }}
                            >
                              {rorPending}
                            </h5>
                          </div>

                          {/* Completed */}
                          <div className="flex-fill ps-3">
                            <div className="small text-muted mb-1">
                              Completed
                            </div>
                            <h5
                              className="fw-bold mb-0 text-start"
                              style={{ color: "#0192d5" }}
                            >
                              {rorCompleted}
                            </h5>
                          </div>
                        </div>
                        <div className="mt-3">
                          {/* <CommonProgressBar
                            percentage={RorPercentage}
                            primaryColor="#0192d5"
                            secondaryColor="#d6f2fe"
                            textColor="#ffffff"
                          /> */}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={4}>
                    <Card
                      className="border-0 h-100"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#e9e5fe",
                        borderRadius: "8px",
                      }}
                    >
                      <Card.Body className="p-3">
                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="fw-bold cardTite_inf">Editor</span>
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#6c54e6" }}
                          >
                            edit_square
                          </span>
                        </div>

                        {/* Two Column Section */}
                        <div className="d-flex">
                          {/* Pending */}
                          <div className="flex-fill pe-2 border_right_dashboardCase_Editor">
                            <div className="small text-muted mb-1">Pending</div>
                            <h5
                              className="fw-bold mb-0 text-start"
                              style={{ color: "#ee383d" }}
                            >
                              {editorPending}
                            </h5>
                          </div>

                          {/* Completed */}
                          <div className="flex-fill ps-3">
                            <div className="small text-muted mb-1">
                              Completed
                            </div>
                            <h5
                              className="fw-bold mb-0 text-start"
                              style={{ color: "#6c54e6" }}
                            >
                              {editorCompleted}
                            </h5>
                          </div>
                        </div>
                        <div className="mt-3">
                          {/* <CommonProgressBar
                            percentage={EditorPercentage}
                            primaryColor="#6c54e6"
                            secondaryColor="#e9e5fe"
                            textColor="#ffffff"
                          /> */}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </>
          ),
        },
      ])}
    </>
  );
};

export default CaseActionSummary;
